import React from 'react';
import {OkayIcon, GoodIcon, PoorIcon, VeryGoodIcon, VeryPoorIcon} from './FeedbackIcons';
import './Feedback.scss'

const getTheme = (/** @type {string} */ themeName) => {
    if (themeName === "monochrome") {
        const lineColour = '#4D6570'
        const backgroundColour = '#7ec4bb'
        return [
            { key: 'very poor', label: 'Very poor', icon: VeryPoorIcon, borderColour: lineColour, backgroundColour: backgroundColour },
            { key: 'poor', label: 'Poor', icon: PoorIcon, borderColour: lineColour, backgroundColour: backgroundColour },
            { key: 'ok', label: 'OK', icon: OkayIcon, borderColour: lineColour, backgroundColour: backgroundColour },
            { key: 'good', label: 'Good', icon: GoodIcon, borderColour: lineColour, backgroundColour: backgroundColour },
            { key: 'very good', label: 'Very good', icon: VeryGoodIcon, borderColour: lineColour, backgroundColour: backgroundColour }
        ]
    }
    return [
        { key: 'very poor', label: 'Very poor', icon: VeryPoorIcon, borderColour: '#0a6457', backgroundColour: '#FFF1EE' },
        { key: 'poor', label: 'Poor', icon: PoorIcon, borderColour: '#964E1E', backgroundColour: '#FEF5C5' },
        { key: 'ok', label: 'OK', icon: OkayIcon, borderColour: '#4D6570', backgroundColour: '#F2F5F6' },
        { key: 'good', label: 'Good', icon: GoodIcon, borderColour: '#1463AA', backgroundColour: '#ECF5FD' },
        { key: 'very good', label: 'Very good', icon: VeryGoodIcon, borderColour: '#306E33', backgroundColour: '#E6F9E7' }
    ]
}

export const RatingIcons = (/** @type {{ selectedRating: string; themeName: string; onRatingChanged: (key: string, borderColour: string) => void }} */ { selectedRating, onRatingChanged, themeName }) => {
    const theme = getTheme(themeName)
    return (
        <div className={'ratings'}>
            {theme.map(({ key, label, icon: Icon,borderColour, backgroundColour }) => (
                <div className={`rating-container ${selectedRating === key ? " selected" : ""}`}>
                    <div onClick={() => onRatingChanged(key, borderColour)} 
                         style={{backgroundColor: `${backgroundColour}`, border: `1px solid ${borderColour}`, boxShadow: `inset 0 0 0 2px ${selectedRating === key ? borderColour : "white"}` }}
                         className={"rating-icon"}>
                        <Icon colour={borderColour}/>
                    </div>
                    <p>{label}</p>
                </div>
            ))}
        </div>
    );
};

export const SubmittedFeedbackSuccess = () => {
    return <>
        <h1>Thank you!</h1>
        <p>
            We actively use your feedback to improve our platform and shape our decisions about what we work on
            next.
        </p>
    </>
};
